import React from "react";
import { Box, Typography, Button, Checkbox, Divider, Grid } from "@mui/material";
import { useModal } from "../../context/ModalContext";
import { useState } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

export default function PlotDocumentSection({ documentVerified, handlePayment, documents, loading, isSoldOut = false, onProceedToKYC, kycVerified = false, navigatePath }) {
  const { requireLogin } = useModal()
  const [acceptTerms, setAcceptTerms] = useState(false);
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        width: "100%",
        p: 2,
        mb: 2,
        borderRadius: 3,
        boxShadow: 2,
        backgroundColor: "#fff",
      }}
    >
      <Box
        sx={{
          maxHeight: documents.length > 4 ? 280 : "auto", 
          overflowY: documents.length > 4 ? "auto" : "visible",
        }}
      >
        <Typography
          align="center"
          variant="h5"
          sx={{
            textAlign: "center"
          }}
        >
          Property Documents
        </Typography>
        
        <Grid container columnGap={4} rowGap={2} justifyContent={"center"} mt={2}>
          {documents.length > 0 ? (
            documents.map((doc, idx) => (
              <Grid item xs={12} md={6} key={doc.id}>
                <Box
                  sx={{
                    p: 2,
                    mb: 2,
                    mt: 2,
                    borderRadius: 3,
                    boxShadow: 2,
                    backgroundColor: "#fff",
                    width: "100%",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 1,
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                      <img
                        src="/assets/icons/legal_document.png"
                        alt="support"
                        style={{ width: 50, height: "auto" }}
                      />
                      <Typography fontWeight={600} sx={{ fontSize: { xs: 16, sm: 18 } }}>
                        {doc?.douc_type || `Document ${idx + 1}`}
                      </Typography>
                    </Box>

                    <Typography sx={{ fontSize: { xs: 12, sm: 14 }, color: "text.secondary" }}>
                      View and download this document
                    </Typography>

                    <Box sx={{ display: "flex", gap: 1, mt: 1 }}>
                      <Button
                        variant="contained"
                        sx={{
                          textTransform: "none",
                          flex: 1,
                          backgroundColor: documentVerified ? "primary.main" : (isSoldOut ? "grey.400" : "red"),
                          color: "white",
                          cursor: isSoldOut ? "not-allowed" : "pointer",
                          opacity: isSoldOut ? 0.6 : 1,
                          "&:hover": {
                            backgroundColor: documentVerified ? "primary.dark" : (isSoldOut ? "grey.400" : "grey.500"),
                          },
                        }}
                        onClick={() => {
                          if (isSoldOut) return;
                          if (documentVerified) {
                            window.open(doc.file, "_blank");
                          }
                          else {
                            toast.error("Complete the Document Verification to Unlock Document")
                          }
                        }}
                        disabled={isSoldOut}
                      >
                        {documentVerified ? "View" : "Unlock"}
                      </Button>
                    </Box>
                  </Box>
                </Box>
              </Grid>
            ))
          ) : (
            <Typography sx={{ textAlign: "center" }}>No Documents Found</Typography>
          )}
        </Grid>
      </Box>
      {documentVerified && onProceedToKYC && (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
          <Button
            variant="contained"
            sx={{
              backgroundColor: kycVerified ? "#608900" : "#FEB821",
              color: kycVerified ? "#fff" : "#000",
              textTransform: "none",
              fontWeight: "bold",
              px: 4,
              py: 1.5,
              borderRadius: "50px",
              cursor: "pointer",
              "&:hover": { backgroundColor: kycVerified ? "#4a6a00" : "#e4a61b" },
            }}
            onClick={() => {
              if (kycVerified && navigatePath) {
                navigate(navigatePath);
              } else if (!kycVerified) {
                onProceedToKYC();
              }
            }}
          >
            {kycVerified ? "KYC added" : "Proceed to KYC"}
          </Button>
        </Box>
      )}
    </Box>
  );
}
